import { TableColumn, TableGroupAction, TableRowAction } from './table.model';
import { QueryKey } from 'react-query';
import { FilterItem } from '../../../../model/filter';
import { BaseEntity, ListRequestDto, ListResponseDto } from '../../../../model';
import { UserAction } from '../../../../model/actions/user.action';

export interface DataTableProps<TModel extends BaseEntity, TFilter extends Record<string, any> = TModel> {
  id: string;
  queryKey: QueryKey;
  itemId?: string | ((item: any) => string);
  columns: TableColumn<TModel>[];
  fetchData: (requestData: ListRequestDto<TFilter>) => Promise<ListResponseDto<TModel>>;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  onPage?: number;
  filter?: FilterItem[];
  rowActions?: TableRowAction<TModel>[];
  groupActions?: TableGroupAction[];
  toolbarActions?: UserAction<TModel>[];
}

export const DEFAULT_DATA_TABLE_PROPS: Partial<DataTableProps<any>> = {
  sortOrder: 'asc',
  onPage: 10,
  filter: [],
  rowActions: [],
  groupActions: [],
  toolbarActions: [],
};
